var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item && _vm.item.status)?_c('div',{staticClass:"issue-status-table-cell"},[_c('centralized-issue-status',{attrs:{"status":_vm.item.status,"compact":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }